import { callBackendService } from '../index';
const win: any = window;

//win['clientToken'] = "fb5bb919-2e55-4b21-a122-5ddc3ffa6233"
const token = win['clientToken'];

interface PincodeProps {
	transactionId: string
	pinCode: string
}

interface SendPincodeProps {
	idType: string
	idNumber: string
	msisdn: string
	lang: string
}
interface CheckComplain{
	srNumber:string
	idNumber:string
}
const getCategories = async () => await callBackendService('/complaint/v1/categories', 'get', null, token);
const getCities = async (regionId: any) => await callBackendService(`/complaint/v1/lookup/region?regionId=${regionId}`, 'get', null, token);
const getIDTypes = async () => await callBackendService('/common-apis/v1/customer/id-types', 'get', null, token);

const sendPincode = async (payload: SendPincodeProps) => await callBackendService(`/common-apis/v1/customer/profile/id?idType=${payload.idType}&idNumber=${payload.idNumber}&msisdn=${payload.msisdn}&lang=${payload.lang}`,
	'get',
	null,
	token);
const createComplain = async (payload: any) => await callBackendService("/complaint/v1/consumer", 'post', payload, token);
const validatePincode = async (payload: PincodeProps) => await callBackendService("/profile/pincode", 'post', payload, token);
const checkComplain = async (payload: CheckComplain) => await callBackendService(`/complaint/v1/consumer?srNumber=${payload.srNumber}&idNumber=${payload.idNumber}&san=""}`, 'get', null, token);



export const complainsApi = { getCategories, getCities, getIDTypes, sendPincode, createComplain, validatePincode,checkComplain };
